import { createFileRoute } from "@tanstack/react-router";
import { getLocale } from "@/paraglide/runtime";
import {
  blogPostsByTagQueryOptions,
  blogTagQueryOptions,
} from "@/tools/blog/hooks/use-blog-data";
import { BlogTagPage } from "@/tools/blog/pages/BlogTagPage";

export const Route = createFileRoute("/blog/tags/$tag")({
  component: BlogTagRoute,
  ssr: true,
  loader: async ({ context, params }) => {
    const locale = getLocale();
    await context.queryClient.ensureQueryData(
      blogTagQueryOptions(params.tag, locale),
    );
    context.queryClient.prefetchQuery(
      blogPostsByTagQueryOptions(params.tag, locale),
    );
  },
  head: ({ params }) => ({
    // Tag archives are auto-generated groupings — keep them out of the index to
    // avoid thin-content/index-bloat, but follow links so posts get crawled.
    meta: [
      { title: `Tag: ${params.tag} | Toolverse Blog` },
      {
        name: "description",
        content: `Toolverse blog posts tagged "${params.tag}" — F1 Fantasy guides, strategy, and data analysis.`,
      },
      { name: "robots", content: "noindex, follow" },
    ],
  }),
});

function BlogTagRoute() {
  const { tag } = Route.useParams();
  return <BlogTagPage tag={tag} />;
}
